<rcp-oup-claim-search-two-col-layout [hideLeftColumn]="true">
    <div left-hand-col></div>

    <div navigation>
        <rcp-oup-claim-search-navigation></rcp-oup-claim-search-navigation>
    </div>

    <div navigation-right>
        <rcp-oup-stalled-claim-filter
            [filterId]="
                STALLED_CLAIM_FILTER_IDS.SEARCH_CLAIMS
            "></rcp-oup-stalled-claim-filter>
    </div>

    <div filter class="flex flex-row items-center w-full p-4">
        <div class="flex-0 w-full">
            <rcp-com-form [formGroup]="searchForm" [doShowFormActions]="false">
                <div
                    class="flex flex-row flex-wrap items-center gap-x-4 gap-y-2">
                    <div>
                        <rcp-com-input
                            controlName="claimNbr"
                            labelVertical="{{
                                pmSystem?.id === PM_SYSTEM_IDS.COMPULINK
                                    ? 'Acct #'
                                    : 'Claim #'
                            }}"
                            [tabOrder]="0"
                            [inputWidth]="140"
                            [doShowMaxLength]="false"
                            (keyup.enter)="search()"></rcp-com-input>
                    </div>
                    <div>
                        <rcp-com-input
                            controlName="patientName"
                            labelVertical="Patient"
                            [tabOrder]="0"
                            [sideLabelWidth]="140"
                            [doShowMaxLength]="false"
                            (keyup.enter)="search()"></rcp-com-input>
                    </div>
                    <div>
                        <rcp-com-input
                            controlName="payorName"
                            labelVertical="Payer"
                            [tabOrder]="0"
                            [sideLabelWidth]="140"
                            [doShowMaxLength]="false"
                            (keyup.enter)="search()"></rcp-com-input>
                    </div>
                    <div class="flex flex-col">
                        <div class="font-semibold">Service Date: From - To</div>
                        <div class="flex flex-row">
                            <rcp-oup-datepicker
                                class="pr-2"
                                controlName="serviceDateFrom"
                                [maxDate]="TODAY"
                                [tabOrder]="0"
                                [inputWidth]="160"
                                (keyup.enter)="search()"></rcp-oup-datepicker>
                            <rcp-oup-datepicker
                                controlName="serviceDateTo"
                                [maxDate]="TODAY"
                                [tabOrder]="0"
                                [inputWidth]="160"
                                (keyup.enter)="search()"></rcp-oup-datepicker>
                        </div>
                    </div>
                    <div class="w-[200px]">
                        <rcp-com-select
                            labelVertical="Status"
                            placeholderLabel="Select Statuses"
                            [tabOrder]="0"
                            controlName="status"
                            [options]="statusOptions"
                            [multiple]="true"
                            [includeSelectAll]="true"></rcp-com-select>
                    </div>
                    <div class="flex flex-row pt-3 space-x-2">
                        <rcp-com-button
                            [buttonStyle]="ButtonStyle.Primary"
                            label="Search"
                            (click)="search()"
                            (keyup.enter)="search()"></rcp-com-button>
                        <rcp-com-button
                            [buttonStyle]="ButtonStyle.Secondary"
                            label="Clear"
                            (click)="clearSearch()"></rcp-com-button>
                    </div>
                </div>
            </rcp-com-form>
            <div
                *ngIf="!searchForm.valid && searchForm.errors['dateRangeValid']"
                class="flex flex-row text-red-400 text-sm">
                <div class="w-[710px]"></div>
                <span class="font-semibold">"From"&nbsp;</span>
                date must be before
                <span class="font-semibold">&nbsp;"To"&nbsp;</span> date
            </div>
        </div>
    </div>

    <div class="w-full h-full">
        <rcp-oup-grid
            *ngIf="hasSearchCriteria && dataSource"
            [dataSource]="dataSource"
            [tableStateId]="tableId"
            [gridOptions]="gridOptions"
            [columns]="cols"
            [pagination]="pagination"
            [sortActive]="sortActive"
            [sortDirection]="sortDirection"
            [gridRowNavigation]="gridRowNavigation"
            [rowDataComparisonKey]="'id'"
            [isLoading]="isLoading"
            [rowClassRules]="rowClassRules"
            [noDataMessage]="noDataMessage"
            (paginationChanged)="pageChanged($event)"
            (sortChanged)="sortChanged()">
        </rcp-oup-grid>
        <div
            *ngIf="!hasSearchCriteria"
            class="w-full flex flex-row justify-center items-center h-full border-t border-t-gray-border">
            <div class="font-semibold text-xl p-4">
                Enter One Or More Search Criteria
            </div>
        </div>
    </div>
</rcp-oup-claim-search-two-col-layout>
